module.exports = __webpack_public_path__ + "img/bbva.4f48be93.png";